export enum TaskStatus {
    Unknown     = 0,
    Created     = 1,
    Inprogress  = 2,
    Done        = 3,
}

export const TaskStatusIcon = {
    [TaskStatus.Unknown]: 'vzi-question',
    [TaskStatus.Created]: 'vzi-idea',
    [TaskStatus.Inprogress]: 'vzi-construction',
    [TaskStatus.Done]: 'vzi-check',
}

export const TaskStatusColor = {
    [TaskStatus.Unknown]: 'txt-l',
    [TaskStatus.Created]: 'txt-ok',
    [TaskStatus.Inprogress]: 'txt-pl',
    [TaskStatus.Done]: 'txt-pd',
}

export const TaskStatusName = {
    [TaskStatus.Unknown]: 'Неизвестно',
    [TaskStatus.Created]: 'Создана',
    [TaskStatus.Inprogress]: 'В работе',
    [TaskStatus.Done]: 'Выполнена',
}

export const TaskStatusText = {
    [TaskStatus.Unknown]: 'Задача переведена в статус "Неизвестно"',
    [TaskStatus.Created]: 'Задача переведена в статус "Создана"',
    [TaskStatus.Inprogress]: 'Задача переведена в статус "В работе"',
    [TaskStatus.Done]: 'Задача переведена в статус "Выполнена"',
}
